import {
	Button,
	createStyles,
	Divider,
	Fade,
	Grid,
	Hidden,
	Paper,
	Theme,
	Typography,
	WithStyles,
	withStyles,
  Dialog,
  DialogActions ,
  DialogContent ,
  DialogContentText,
} from '@material-ui/core'
import moment from 'moment'
import * as Papa from 'papaparse';
import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Link, withRouter } from 'react-router-dom';


import { renderOnServiceAndActivityType } from 'src/Forms/Outcomes/formUtils';
import { getActivityCodeById } from '../../services/code.service'
import {
	getActivityActualsByActivityID,
	getActivityById,
	getParticipantsByActivityId
} from '../../services/enrollment.service'
import { logErrorAndGetEmptyString, logErrorWithCustomReturn, simpleErrorLogger } from '../../services/errorHandlers'
import { Activity } from '../../services/Model/Activity'
import {   CompletionOutcomeStatusItems } from '../../services/Model/Outcome'
import { ActivityParticipant } from '../../services/Model/Participant'
import {  getParticipantData } from '../../services/participant-service'
import ParticipantsTable, { TableItemWithParticipantInfo } from '../../Tables/ParticipantsTable/ParticipantsTable'
import CodeZone from '../CodeZone/CodeZone'
import DefaultLoaderModal from '../DefaultLoaderModal/DefaultLoaderModal'
import Outcomes from '../Outcomes/Outcomes';
import TypographyHeader from '../Templates/TypographyHeader/TypographyHeader'

interface SingleActivityProps extends WithStyles<typeof styles> { }

interface SingleActivityState {
	currentActivity?: Activity
	participants: TableItemWithParticipantInfo[]
	loadingParticipants: boolean
	outcomeActuals: any[]
	hideActivityOutcomesBtn: boolean
  enrollmentDisabledDialogOpen: boolean
}

export type RouterProps = SingleActivityProps & RouteComponentProps<{ activityID: string }>

const INITIAL_STATE: SingleActivityState = {
	participants: [],
	loadingParticipants: true,
	outcomeActuals: [],
	hideActivityOutcomesBtn: false,
  enrollmentDisabledDialogOpen: false
}

export class SingleActivity extends React.Component<RouterProps, SingleActivityState> {
	public readonly state: SingleActivityState = INITIAL_STATE

	handleParticipantOutcomeError = (participant: ActivityParticipant) => {
		const { firstName, middleInitial, lastName } = participant
		const participantName = `${lastName}, ${firstName} ${middleInitial || ''}`

		return {
			...participant,
			title: {
				label: participantName,
				url: `${this.props.match.url}/participants/`,
			},
			content: [{ isDate: true, value: participant.enrollmentDate || '' }, { isDate: false, value: '' }],
			status: 'NO_STATUS',
		}
	}

	normalizeParticipantsData = (activityParticipants: ActivityParticipant[]) => {
		const arrayOfPromises = activityParticipants.map(async (participant) => {
			const participantOutcome = participant
      participantOutcome.quest = participantOutcome.quest === 0 ? 0 : participantOutcome.quest === 1 ? 1 : -1
			return participantOutcome
				? this.outcomeHandler(participant)
				: this.handleParticipantOutcomeError(participant)
		})

		return Promise.all(arrayOfPromises)
	}

	outcomeHandler = (participant: ActivityParticipant) => {
		const { firstName, middleInitial, lastName } = participant
		const participantName = `${lastName}, ${firstName} ${middleInitial || ''}`
    const quest = participant.quest === 1 ? 'Y' : participant.quest === 0 ? 'N' : ''
		return {
			...participant,
			title: {
				label: participantName,
				url: `${this.props.match.url}/participants/`,
			},
			content: [
				{ isDate: true, value: participant.enrollmentDate || '' },
        {isDate: true, value: participant.outcomeActualStartDate || '', label: 'Outcome Start Date'},
				{ isDate: false, value: CompletionOutcomeStatusItems.find((i) => i.label.toUpperCase() === participant.status?.toUpperCase())?.value },
        { isDate: false , value: quest },
			],
			status: CompletionOutcomeStatusItems.find((i) => i.label.toUpperCase() === participant.status?.toUpperCase())?.value ,
		}
	}

	fetchParticipantInfo = async () => {
		const { match } = this.props
		const { activityID } = match.params

		const activityInfo = await getActivityById(activityID).catch(logErrorAndGetEmptyString)
		const activityParticipants: ActivityParticipant[] = await getParticipantsByActivityId(activityID).catch(
			logErrorWithCustomReturn([]),
		)
		const flatParticipants = await this.normalizeParticipantsData(activityParticipants).catch(
			logErrorWithCustomReturn([]),
		)
		const outcomeActualData = await getActivityActualsByActivityID(activityID).catch(logErrorWithCustomReturn([]));
		const { participantType, serviceType } = activityInfo

		this.setState({
			currentActivity: activityInfo,
			participants: flatParticipants,
			loadingParticipants: false,
			outcomeActuals: outcomeActualData,
			hideActivityOutcomesBtn: !renderOnServiceAndActivityType(participantType, serviceType)
		})
	}

	handleClickEnrollParticipant = async () => {
    if(!this.state.currentActivity || !this.state.currentActivity.enrolling){
      this.setState((prevState) => ({
        ...prevState,
        enrollmentDisabledDialogOpen: true
      }))
    }
    else{
      const code = await getActivityCodeById(this.props.match.params.activityID).catch((e) => {
        throw Error(e)
      })
      if (code) window.open(`${process.env.REACT_APP_PARTICIPANT_PORTAL_URL}?code=${code}`)
    }
		
	}

	handleParticipantUpdate = () => {
		this.fetchParticipantInfo().catch(simpleErrorLogger)
	}

	handleDownloadParticipantData = async () => {

		const now = moment().unix().toString();
		const data = await getParticipantData(
			this.state.currentActivity && this.state.currentActivity.id ? this.state.currentActivity.id : '')
		const dataWithoutSpecialCharacters = JSON.stringify(data).replace(/[#]/gm, '');
		// @ts-ignore
		const csv = Papa.unparse(dataWithoutSpecialCharacters);


		const hiddenElement = document.createElement('a');
		hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
		hiddenElement.target = '_blank';
		hiddenElement.download = ((this.state.currentActivity && this.state.currentActivity.name) ?
			this.state.currentActivity.name + now : now) + ".csv";
		hiddenElement.click();
	}

	renderHeader = (classes: any, activityID: string, currentActivity?: Activity) => {
		if (!currentActivity) return

		return (
			<section>
				<div className={classes.activityInfo}>
					<TypographyHeader label={currentActivity.name} type={'title'} />

					{!!currentActivity.enrolling && (
						<CodeZone activityId={activityID} />
					)}
				</div>
				<div className={classes.headers}>
					<Typography
						variant={'h6'}
						component={'h3'}
						className={classes.typographyHeader}
					>
						Partnership&#58;
						<span className={classes.typographyLabel}> {currentActivity.partnershipName} </span>
					</Typography>

					<Typography
						variant={'h6'}
						component={'h3'}
						className={classes.typographyHeader}
					>
						Addendum&#58;
						<span className={classes.typographyLabel}> {currentActivity.addendumName} </span>
					</Typography>

					<Typography
						variant={'h6'}
						component={'h3'}
						className={classes.typographyHeader}
					>
						DMS Cohort ID&#58;
						<span className={classes.typographyLabel}> {currentActivity.id} </span>
					</Typography>
				</div>
			</section>
		)
	}

	public async componentDidMount() {
		await this.fetchParticipantInfo()
	}

  handleDialogClose = () => {
    this.setState((prevState) => ({
      ...prevState,
      enrollmentDisabledDialogOpen: false
    }));
  }

	render() {
		const { classes, match } = this.props
		const { activityID } = match.params
		const { currentActivity, hideActivityOutcomesBtn, loadingParticipants, outcomeActuals, participants,enrollmentDisabledDialogOpen } = this.state

		return loadingParticipants ? (
			<DefaultLoaderModal loading={loadingParticipants} />
		) : (
      <>
        <Dialog
          open={enrollmentDisabledDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Typography variant="h6" component="h6" data-auto="survey-header">
            The Enrollment Period for this activity has ended. To re-open enrollment, please submit the Enrollment Period Extension Request Form available at the top of your Activities list on this site.
            </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button id="reject-enroll" onClick={this.handleDialogClose}>Close</Button>
          </DialogActions>
      </Dialog>

      <Fade in={!loadingParticipants} timeout={{ enter: 1000 }}>
					<Paper elevation={2} className={classes.root}>
						{this.renderHeader(classes, activityID, currentActivity)}

						<Divider variant="middle" className={classes.divider} />

						<Grid container={true} spacing={8} justify="space-between">
							<Grid item={true} xs={12} md={6}>
								<TypographyHeader label="Targets:" type={'subtitle'} />
							</Grid>
							<Hidden
								smDown={true}
								xlDown={hideActivityOutcomesBtn}
							>
								<Grid item={true} xs={12} md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
									<Link to={`${this.props.match.url}/outcome`} style={{ textDecoration: 'none' }}>
										<Button
											variant="contained"
											size="medium"
											className={classes.button}
											data-auto="activity outcomes"
										>
											Activity Outcome
									</Button>
									</Link>
								</Grid>
							</Hidden>
						</Grid>

						<Grid container={true} spacing={8} className={classes.activitySection} data-auto="activity-details-outcomes">
							<Outcomes outcomes={outcomeActuals} />
						</Grid>

						<Divider variant="middle" className={classes.divider} />

						<div className={classes.participantsInfo}>
							<div className={classes.infoHeader}>
								<div className={classes.participantsLabel}>
									<TypographyHeader label="Participants:" type={'subtitle'} />
									<Button
										variant="contained"
										size="medium"
										className={classes.button}
										onClick={this.handleDownloadParticipantData}
										data-auto="download-csv"
									>
										Download Participant Data
								</Button>

								</div>

								<div className={classes.enrollingSection}>
									<TypographyHeader
										label={`Activity Enrollment is ${
											currentActivity && currentActivity.enrolling ? 'enabled' : 'disabled'
											}`}
										type={'subtitle'}
									/>
									{/* <Hidden smDown={true} smUp={!currentActivity || !currentActivity.enrolling}> */}
										<Button
											// disabled={currentActivity && !currentActivity.enrolling}
											variant="contained"
											size="medium"
											className={classes.button}
											onClick={(e) => {
												e.preventDefault()
												this.handleClickEnrollParticipant().catch(simpleErrorLogger)
											}}
											data-auto="enroll-participant-btn"
										>
											Enroll Participant
									</Button>
									{/* </Hidden> */}
								</div>
							</div>
							<ParticipantsTable
								participants={participants}
								loading={loadingParticipants}
								onParticipantInfoUpdate={this.handleParticipantUpdate}
							/>
						</div>
					</Paper>
				</Fade>
      </>
			)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			width: '100%',
			padding: `${theme.spacing.unit}px`,
		},
		participantsLabel: {},
		button: {
			margin: '0 5px'
		},
		enrollingSection: {
			display: 'flex',
			alignItems: 'flex-end',
			flexDirection: 'column',

			[theme.breakpoints.down('sm')]: {
				alignItems: 'flex-start',
			},
		},
		activityInfo: {
			display: 'flex',
			justifyContent: 'space-between',

			[theme.breakpoints.down('md')]: {
				flexDirection: 'row',
				justifyContent: 'space-between',
			},

			[theme.breakpoints.down('sm')]: {
				flexDirection: 'column',
				alignItems: 'flex-start',
			},
		},
		participantsInfo: {
			marginTop: `${theme.spacing.unit * 2}px`,
		},
		infoHeader: {
			display: 'flex',
			justifyContent: 'space-between',
			marginBottom: `${theme.spacing.unit * 2}px`,

			[theme.breakpoints.down('sm')]: {
				flexDirection: 'column-reverse',
				alignItems: 'flex-start',
			},
		},
		divider: {
			margin: `${theme.spacing.unit * 1.5}px 0`,
		},
		activitySection: {},
		headerContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			margin: `0 ${theme.spacing.unit}px`,
		},
		headers: {
			display: 'flex',
			flexDirection: 'column'
		},
		typographyHeader: {
			fontWeight: 700
		},
		typographyLabel: {
			fontWeight: 500
		}
	})

export default withRouter(withStyles(styles)(SingleActivity))
